import { render, staticRenderFns } from "./fmFilePreview.vue?vue&type=template&id=aa24d796&"
import script from "./fmFilePreview.vue?vue&type=script&lang=js&"
export * from "./fmFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports